webpackJsonp([63520936819716],{

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header2 = function (_React$Component) {
	  _inherits(Header2, _React$Component);
	
	  function Header2() {
	    _classCallCheck(this, Header2);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Header2.prototype.getStartText = function getStartText() {
	    return this.props.text.split(this.props.decoration.text)[0];
	  };
	
	  Header2.prototype.getEndText = function getEndText() {
	    return this.props.text.split(this.props.decoration.text)[1];
	  };
	
	  Header2.prototype.renderHeader = function renderHeader() {
	    return _react2.default.createElement(
	      'h2',
	      { className: 'text ' + (this.props.className ? this.props.className : '') },
	      this.props.text
	    );
	  };
	
	  Header2.prototype.renderModule = function renderModule() {
	    var component = this.renderHeader();
	
	    if (this.props.decoration) {
	      component = _react2.default.createElement(
	        'h2',
	        { className: 'text ' + (this.props.className ? this.props.className : '') },
	        this.getStartText(),
	        _react2.default.createElement(
	          'span',
	          { className: this.props.decoration.type + ' ' + this.props.decoration.color },
	          this.props.decoration.text
	        ),
	        this.getEndText()
	      );
	    }
	
	    return component;
	  };
	
	  Header2.prototype.render = function render() {
	    return this.renderModule();
	  };
	
	  return Header2;
	}(_react2.default.Component);
	
	exports.default = Header2;
	module.exports = exports['default'];

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Quote = function Quote(props) {
	  return _react2.default.createElement(
	    'blockquote',
	    { className: 'text quote ' + (props.className ? props.className : '') },
	    _react2.default.createElement(
	      'p',
	      null,
	      props.text
	    )
	  );
	};
	exports.default = Quote;
	module.exports = exports['default'];

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _navbar = __webpack_require__(9);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _layout = __webpack_require__(10);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _button = __webpack_require__(18);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _superheader = __webpack_require__(16);
	
	var _superheader2 = _interopRequireDefault(_superheader);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _header3 = __webpack_require__(59);
	
	var _header4 = _interopRequireDefault(_header3);
	
	var _para = __webpack_require__(12);
	
	var _para2 = _interopRequireDefault(_para);
	
	var _para3 = __webpack_require__(13);
	
	var _para4 = _interopRequireDefault(_para3);
	
	var _quote = __webpack_require__(156);
	
	var _quote2 = _interopRequireDefault(_quote);
	
	var _tags = __webpack_require__(43);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _footer = __webpack_require__(42);
	
	var _JuerixHomepage = __webpack_require__(355);
	
	var _JuerixHomepage2 = _interopRequireDefault(_JuerixHomepage);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tags = [{
	  tag: 'Branding',
	  label: 'Branding'
	}, {
	  tag: 'Design',
	  label: 'UI Design'
	}, {
	  tag: 'Develop',
	  label: 'Development'
	}];
	
	var Project = function (_React$Component) {
	  _inherits(Project, _React$Component);
	
	  function Project() {
	    _classCallCheck(this, Project);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Project.prototype.render = function render() {
	    return _react2.default.createElement(
	      _layout2.default,
	      { key: 'main-layout' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Case Study: Juerix. Designing an Ecosystem'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'Incorporating trust, quality & credibility in an online designer jewellery marketplace' }),
	        _react2.default.createElement('meta', { property: 'og:url', content: 'https://surebro.com/case-studies/juerix' }),
	        _react2.default.createElement('meta', { property: 'og:title', content: 'Case Study: Juerix. Designing an Ecosystem' }),
	        _react2.default.createElement('meta', { property: 'og:description', content: 'Incorporating trust, quality & credibility in an online designer jewellery marketplace' }),
	        _react2.default.createElement('meta', { property: 'og:image', content: 'https://res.cloudinary.com/surebro/image/upload/v1530280290/Social-share-cover_t18uos.png' })
	      ),
	      _react2.default.createElement(_navbar2.default, { key: 'navbar', active: 1, className: 'blue' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'CaseStudy' },
	        _react2.default.createElement(
	          'section',
	          { className: 'container CaseStudy-banner' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row justify-content-flex-start' },
	            _react2.default.createElement(_superheader2.default, {
	              key: 'title',
	              className: 'text-left darkgray stronger',
	              text: 'Designing an Ecosystem'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row justify-content-flex-start' },
	            _react2.default.createElement(_header2.default, {
	              key: 'subtitle',
	              className: 'text-left grey regular CaseStudy-banner-subtitle',
	              text: 'Incorporating trust, quality & credibility in an online designer jewellery marketplace.'
	            })
	          ),
	          _react2.default.createElement(_tags2.default, {
	            key: 'project-tags',
	            tags: tags
	          })
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'container CaseStudy-body' },
	          _react2.default.createElement(_header4.default, { text: 'A marketplace like no other' }),
	          _react2.default.createElement(_para2.default, {
	            key: 'text-1',
	            className: 'text-left grey',
	            text: 'The founders of Juerix had a vision for what they wanted Juerix to be. They wanted to build a designer jewellery marketplace where quality is guaranteed. They wanted this to be very clear in all their customer facing products.'
	          }),
	          _react2.default.createElement(_para2.default, {
	            key: 'text-2',
	            className: 'text-left grey',
	            text: 'Juerix was going to showcase and sell designs from awards winning jewellery designers and we were asked to built something that did justice to the designers.'
	          })
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'section',
	          { className: 'container CaseStudy-body' },
	          _react2.default.createElement(_quote2.default, { text: 'Our aim was to build our version of Art' })
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'section',
	          { className: 'CaseStudy-product-design' },
	          _react2.default.createElement('img', { className: 'CaseStudy-product-design-image', src: 'https://res.cloudinary.com/surebro/image/upload/q_auto/case-study/juerix/JuerixHomepage.c494db9c', alt: 'juerix' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'CaseStudy-product-design-content' },
	            _react2.default.createElement(_header2.default, {
	              key: 'title',
	              className: 'text-left strong',
	              text: 'Seven seconds to Impress'
	            }),
	            _react2.default.createElement(_header4.default, {
	              key: 'subtitle',
	              className: 'text-left grey regular',
	              text: 'We had to communicate Juerix\'s USP to users while also balancing it with it\'s business requirements. All that within a small window'
	            }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_para4.default, {
	              key: 'intro',
	              className: 'text-left grey regular',
	              text: 'An average user will form an opinion of a website within the first seven seconds. It was important we could communicate core values to the user within seven seconds.'
	            }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_para4.default, {
	              key: 'intro-2',
	              className: 'text-left grey regular',
	              text: 'We also had to balance this with business requirements. Juerix is a business and without sales, it wouldn\'t be worth the designer\'s time to invest in Juerix.'
	            }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_para4.default, {
	              key: 'intro-3',
	              className: 'text-left grey regular',
	              text: 'Those two requirements forced us to try something new. At the end of the day we were quite happy with the result. It performed well business wise without compromising on the Juerix brand'
	            }),
	            _react2.default.createElement('br', null)
	          )
	        ),
	        _react2.default.createElement(_footer.CaseStudyFooter, null)
	      )
	    );
	  };
	
	  return Project;
	}(_react2.default.Component);
	
	exports.default = Project;
	module.exports = exports['default'];

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/JuerixHomepage.c494db9c.png";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-case-studies-juerix-js-64ad98a98cdf378236e9.js